import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted} from 'vue';
import router from '@/router/index';
import {useStore} from "@/store";
import AproconFooter from '@aprocon-software/aprocon-footer';
import Services from '@/assets/js/services/Services';



    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

    function created(): void {

        if (!router.currentRoute.meta?.logoff) {
            onMounted(() => mounted());
            onUnmounted(() => unmounted());
        }

        if (router.currentRoute.query.bid) {
            store.commit("setBranchId", router.currentRoute.query.bid);
            router.replace({query: undefined});

        }
        if(router.currentRoute.meta?.loginRequired) {
            router.onReady(() => store.dispatch('login'));
        }
    }

    function mounted() : void {
        window.document.addEventListener('onfocus', keepAlive);
        setTimeout(keepAlive, 240000);
    }
    function unmounted() : void {
        window.document.removeEventListener('onfocus', keepAlive);
    }
    async function keepAlive() {
            const success = await Services.Auth.testCredentials();
            if (success) {
                // test credentials every 60 seconds
                setTimeout(keepAlive, 240000);
            } else {
                await store.dispatch('logout');
            }

    }

    created();


return { __sfc: true,store, created, mounted, unmounted, keepAlive, AproconFooter }
}

})